<template>
    <el-upload
        :action="action"
        :drag="drag"
        :show-file-list="showFileList"
        :list-type="listType"
        :file-list="files"
        :accept="accept"
        :multiple="limit>1"
        :limit="limit"
        :on-remove="removeFile"
        :http-request="upload"
        :on-success="onSuccess"
        :on-error="onError"
        :on-exceed="onExceed"
        :on-preview="onPreview"
    >
        <template v-if="drag">
            <i class="el-icon-upload"/>
            <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击上传</em>
            </div>
            <div v-if="tip" class="el-upload__tip" slot="tip">{{tip}}</div>
        </template>
        <template v-else>
            <i slot="default"  class="el-icon-plus"/>
            <div slot="file" slot-scope="{file}" v-loading="isLoading">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="onPreview(file)">
                        <i class="el-icon-zoom-in"/>
                    </span>
                    <span class="el-upload-list__item-delete" @click="removeFile(file)">
                        <i class="el-icon-delete"/>
                    </span>
                </span>
            </div>
        </template>
    </el-upload>
</template>

<script>

export default {
    props: {
        categoryId: {
            type: String,
            default: null
        },
        accept: String,
        drag: {
            type: Boolean,
            default: true
        },
        listType: {
            type: String,
            default: 'text'
        },
        fileList: {
            type: Array,
            default: function(){
                return [];
            }
        },
        showFileList: {
            type: Boolean,
            default: true
        },
        limit: {
            type: Number,
            default: 1
        },
        tip: String
    },
    data() {
        return {
            action: '#',
            files: this.fileList.slice(0),
            isLoading: false
        };
    },
    watch: {
        fileList(newVal) {
            this.files = newVal;
        }
    },
    methods: {
        upload(params) {
            this.isLoading = true;
            let MyFile = new window.BaaS.File();
            MyFile.upload(
                { fileObj: params.file },
                { categoryID: this.categoryId }
            ).then(
                res => {
                    let file = res.data.file;
                    file.url = file.path;
                    this.files.push(file);
                    this.onSuccess(res, file, this.files);
                },
                err => {
                    this.onError(err, params.file, this.files);
                }
            );
        },
        onSuccess(response, file, fileList) {
            this.$emit('success', response, file, fileList);
            this.$message.success('上传成功');
            this.isLoading = false;
        },
        onError(error, file, fileList) {
            this.$emit('error', error, file, fileList);
            this.$message.error('上传失败');
            this.isLoading = false;
        },
        onExceed() {
            this.$message.warning(`最多只能上传${this.limit}个文件`);
        },
        onPreview(file) {
            window.open(file.path);
        },
        removeFile(file) {
            let MyFile = new window.BaaS.File();
            MyFile.delete(file.id).then(
                () => {
                    this.files = this.files.filter(f => f.id !== file.id);
                    this.$emit('remove', file, this.files);
                    this.$message.success(`文件${file.name}已删除`);
                },
                () => {
                    this.$message.error('删除文件失败，请稍后重试');
                }
            );
        }
    }
};
</script>